import React, { useState, useEffect } from "react";
import CurrentDateTime from "../../../utils/CurrentDateTime";
import { BsFilter } from "react-icons/bs";
import { ButtonIcon } from "../../../components/Button";
import { GrPowerReset } from "react-icons/gr";
import { getAuctionDateCategory } from "../../../utils/getArrayOfObjectCategory";
import AuctionSearchComponent from "../component/AuctionSearchComponent";
import { useSelector, useDispatch } from "react-redux";
import NoPropertyFound from "../../../components/NoPropertyFound";
import { getBuyRequest } from "../ReduxStore/actions";
import { checkCurrentTimeWithTargetTime } from "../../../utils/checkCurrentTimeWithTargetTime";
import {
  searchProperty,
  searchTimeWithinAuctionProperty,
} from "../../../utils/searchProperty";
import PuffLoader from "react-spinners/PuffLoader";
import AuctionPagination from "../../../components/AuctionPagination";

let itemsPerPage = 8;
let buyPropertyData = [];

const BuyAuctionPage = () => {
  const [selectedDate, setSelectedDate] = useState(new Date());
  const [pickDate, setPickDate] = useState("");
  const [searchData, setSearchData] = useState([]);
  const [searchOutlet, setSearchOutlet] = useState(false);

  //redux hooks
  const dispatch = useDispatch();
  const { isLoading, buy_properties } = useSelector((state) => state.buyData);

  useEffect(() => {
    dispatch(getBuyRequest());
  }, [dispatch]);

  // Check rent_properties
  if (
    buy_properties &&
    typeof buy_properties === "object" &&
    Object.keys(buy_properties).length > 0
  ) {
    buyPropertyData = Array.isArray(buy_properties.data)
      ? buy_properties.data
      : [];
  } else {
    buyPropertyData = [];
  }

  //filter inspection time
  const auction_properties = buyPropertyData
    .filter((obj) => {
      const hasAuctions = obj.auctions.length > 0;
      const isFutureAuction =
        hasAuctions &&
        obj.auctions.some((item) =>
          checkCurrentTimeWithTargetTime(item.time, item.date)
        );
      return isFutureAuction;
    })
    .sort((a, b) => {
      const dateA = new Date(a.inspections[0].date);
      const dateB = new Date(b.inspections[0].date);
      return dateA - dateB;
    });

  //date change
  const handleDateChange = (event) => {
    setPickDate(event.target.value);
    setSelectedDate(new Date(event.target.value));
  };

  //reset button
  const handleReset = () => {
    setPickDate("");
    setSelectedDate(new Date());
  };

  //search field filter
  const handleSearchInput = (searchCriteria) => {
    const filteredProperties = searchProperty(
      auction_properties,
      searchCriteria
    );
    setSearchData(filteredProperties);
    setSearchOutlet(true);
  };

  return (
    <>
      <AuctionSearchComponent
        totalProduct={auction_properties.length}
        getInput={handleSearchInput}
      />
      <div className="px-[5vw] sm:px-[10vw] xl:px-[15vw] py-10">
        <div className="flex gap-1 items-start uppercase pb-3">
          <BsFilter className="w-5 h-6" />
          <p>Select Auction date</p>
        </div>
        <div className="flex items-center gap-3">
          <input
            type="date"
            className="px-3 py-2 rounded border border-yellow focus:outline-yellow cursor-pointer"
            placeholder="MM-DD-YYYY"
            value={pickDate}
            onChange={handleDateChange}
          />
          <ButtonIcon
            onClick={handleReset}
            Icon={<GrPowerReset />}
            className="px-6 py-[13px] rounded border border-yellow focus:outline-yellow cursor-pointer"
          />
        </div>
        {/* card display division */}
        {isLoading ? (
          <div className="h-[30vh] w-full flex items-center justify-center">
            <PuffLoader color="#36d7b7" size={100} />
          </div>
        ) : searchOutlet ? (
          <>
            {searchData.length === 0 ? (
              <NoPropertyFound className="mt-3" />
            ) : (
              <>
                <AuctionPagination
                  items={Object.entries(getAuctionDateCategory(searchData))}
                  itemsPerPage={itemsPerPage}
                />
              </>
            )}
          </>
        ) : (
          <div>
            {auction_properties.length === 0 && (
              <NoPropertyFound
                className={`${pickDate !== "" ? "hidden" : "block mt-3"}`}
              />
            )}
            {pickDate !== "" ? (
              <div>
                <CurrentDateTime currentDate={selectedDate} />
                {searchTimeWithinAuctionProperty(
                  auction_properties,
                  pickDate
                ) ? (
                  <>
                    <AuctionPagination
                      items={Object.entries(
                        getAuctionDateCategory(auction_properties)
                      )}
                      itemsPerPage={itemsPerPage}
                      pickDate={pickDate}
                    />
                  </>
                ) : (
                  <NoPropertyFound />
                )}
              </div>
            ) : (
              <>
                <AuctionPagination
                  items={Object.entries(
                    getAuctionDateCategory(auction_properties)
                  )}
                  itemsPerPage={itemsPerPage}
                />
              </>
            )}
          </div>
        )}
      </div>
    </>
  );
};

export default BuyAuctionPage;
